'use client';

/**
 * Tier Price Table Component
 * Displays volume pricing tiers on the product page.
 * Shows "Buy More, Save More" table with quantity thresholds, per-unit prices, and savings.
 */
import { c as _c } from "react/compiler-runtime";
interface TierPriceRow {
  minQty: number;
  price: string;
  customerGroupId: number | null;
}
interface TierPriceTableProps {
  tiers: TierPriceRow[];
  basePrice: string;
}
function formatPrice(price: string | number): string {
  return parseFloat(String(price)).toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
}
function calculateSavingsPercent(basePrice: string, tierPrice: string): number {
  const base = parseFloat(basePrice);
  const tier = parseFloat(tierPrice);
  if (base <= 0) return 0;
  return Math.round((base - tier) / base * 100);
}
export function TierPriceTable(t0) {
  const $ = _c(24);
  const {
    tiers,
    basePrice
  } = t0;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  if ($[0] !== basePrice || $[1] !== tiers) {
    t7 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const globalTiers = tiers.filter(_temp);
      if (globalTiers.length === 0) {
        t7 = null;
        break bb0;
      }
      const sortedTiers = [...globalTiers].sort(_temp2);
      const lowestTier = sortedTiers.reduce(_temp3);
      t4 = "tier-price-section";
      t5 = <div className="tier-price-as-low-as">As low as <span className="tier-price-highlight">${formatPrice(lowestTier.price)}</span> each</div>;
      if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = <div className="tier-price-heading">Buy More, Save More</div>;
        $[9] = t6;
      } else {
        t6 = $[9];
      }
      t2 = "tier-price-table";
      if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = <thead><tr><th>Quantity</th><th>Price Each</th><th>You Save</th></tr></thead>;
        $[10] = t3;
      } else {
        t3 = $[10];
      }
      let t8;
      if ($[11] !== basePrice) {
        t8 = tier => {
          const savingsPercent = calculateSavingsPercent(basePrice, tier.price);
          return <tr key={tier.minQty}><td>{tier.minQty}+</td><td>${formatPrice(tier.price)}</td><td className="tier-price-savings">{savingsPercent}%</td></tr>;
        };
        $[11] = basePrice;
        $[12] = t8;
      } else {
        t8 = $[12];
      }
      t1 = sortedTiers.map(t8);
    }
    $[0] = basePrice;
    $[1] = tiers;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
    $[6] = t5;
    $[7] = t6;
    $[8] = t7;
  } else {
    t1 = $[2];
    t2 = $[3];
    t3 = $[4];
    t4 = $[5];
    t5 = $[6];
    t6 = $[7];
    t7 = $[8];
  }
  if (t7 !== Symbol.for("react.early_return_sentinel")) {
    return t7;
  }
  let t8;
  if ($[13] !== t1) {
    t8 = <tbody>{t1}</tbody>;
    $[13] = t1;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t2 || $[16] !== t3 || $[17] !== t8) {
    t9 = <table className={t2}>{t3}{t8}</table>;
    $[15] = t2;
    $[16] = t3;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t4 || $[20] !== t5 || $[21] !== t6 || $[22] !== t9) {
    t10 = <div className={t4}>{t5}{t6}{t9}</div>;
    $[19] = t4;
    $[20] = t5;
    $[21] = t6;
    $[22] = t9;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  return t10;
}
function _temp3(lowest, current) {
  return parseFloat(current.price) < parseFloat(lowest.price) ? current : lowest;
}
function _temp2(a, b) {
  return a.minQty - b.minQty;
}
function _temp(t) {
  return t.customerGroupId === null;
}